import React from 'react'
import NotFoundLayout from '../../layouts/NotFound'

const NotFoundEN = ({ location }) => {
  return (
    <NotFoundLayout location={location}>
      <h2>
        This page doesn't exist. How about visiting one of our other pages?
      </h2>
      <p>Still haven't found what you were looking for?</p>
      <p>
        Talk to us at our{' '}
        <a
          href="https://atendimento.hotmart.com.br/en-us"
          target="_blank"
          rel="noopener noreferrer"
        >
          support center
        </a>
      </p>
    </NotFoundLayout>
  )
}

export default NotFoundEN
